"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.has = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _vue = _interopRequireDefault(require("vue"));
// 权限指令**/
var has = exports.has = _vue.default.directive('has', {
  bind: function bind(el, binding) {
    if (!_vue.default.prototype.$_has(binding.value)) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  },
  inserted: function inserted(el, binding, vnode) {
    if (!_vue.default.prototype.$_has(binding.value)) {
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
});
// 权限检查方法
_vue.default.prototype.$_has = function (value) {
  var isExist = false;
  if (sessionStorage.getItem('userBtns').includes(value)) {
    isExist = true;
  }
  return isExist;
};